import { memo, useMemo } from "react";

import { formatDate } from "@/lib/dayjs/format-date";

type Props = {
	date: string;
};

export const DateOfRoomAndOptionCompositions = memo(({ date }: Props) => {
	const dateText = useMemo(() => formatDate(date, "MM月DD日(ddd)"), [date]);

	return <p className="font-bold">{dateText}</p>;
});
